__turbopack_context__.v({
  "content": "PriceGroup-module-sass-module__w_q3Yq__content",
  "discount": "PriceGroup-module-sass-module__w_q3Yq__discount",
  "list": "PriceGroup-module-sass-module__w_q3Yq__list",
  "notice": "PriceGroup-module-sass-module__w_q3Yq__notice",
  "original-price": "PriceGroup-module-sass-module__w_q3Yq__original-price",
  "row": "PriceGroup-module-sass-module__w_q3Yq__row",
});
